module.exports = __webpack_public_path__ + "img/saved.1fd02c13.svg";